













//import { ResponseModel } from "@dataSource/models/responseModels.ts";
// import { WsResponse } from "@dataSource/api/wsModels/wsResponse";
import { Component, Vue } from "vue-property-decorator";
import WsResponseModel from "../../../dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import BaseResponse from "../../../dataSource/api/Common/ResponseModels/BaseResponse";
@Component({
  name: "uc-profile-block"
})
export default class UcProfileBlockComponent extends Vue {
  get fullName(): string {
    // console.log('this.$dataSource.User',Vue.$dataSource);
    return this.$api.User.FullName.toString();
    //return "Ivanov Ivan"; // без авторизации
    // if (this.$dataStore.user) {
    //   return `${this.$dataStore.user.name || ''} ${this.$dataStore.user.surName || ''}`;
    // }
  }
  logout() {
    //alert("logout");
    this.$api.AccountService.LogoutEvent.once(this.onLogout.bind(this));
    this.$api.AccountService.Logout();
    // .logout().then((res: ResponseModel) => {
    //   if (res.status === 0) {
    //     this.$dataStore.setUser(res);
    //     this.$router.replace('/admin/sign-in');
    //   }
    // });
  }
  onLogout(response: WsResponseModel<BaseResponse>) {
    if (response.IsSuccess) {
      this.$api.SetUser(null);
      this.$router.push({ name: "login" });
    }
  }
  showPanel() {
    this.$emit("panelShow");
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/header/uc-profile-block.vue